import React from "react";
import styled from "styled-components";
import { BaseButton } from "../Section";

const DefaultBtn = styled(BaseButton)`
  background-color: #E9242A;
  color: #fff;
  & .icon {
    > svg {
      fill: #fff;
    }
  }
  &:before {
    background-color: #373636;
  }
`;
const DefaultButton = (props) => {
  const { icon, iconAfter, text, size, ...others } = props;
  return (
    <DefaultBtn className={`btn ${size ? `btn-${size}` : ""} `} {...others}>
      {iconAfter ? (
        <>
          {text && <span className="text">{text}</span>}
          {iconAfter && <span className="icon">{iconAfter}</span>}
        </>
      ) : (
        <>
          {icon && <span className="icon">{icon}</span>}
          {text && <span className="text">{text}</span>}
        </>
      )}
    </DefaultBtn>
  );
};

export default DefaultButton;
